import { useState } from "react";
import { AlertService } from "../../application/services/alertService";

const alertService = new AlertService();

export const useAlert = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [alertsData, setAlertsData] = useState(null);
  const [summaryData, setSummaryData] = useState(null);
  const [heatmapData, setHeatmapData] = useState(null);

  const getAlertsByVmId = async (vmId, index) => {
    setLoading(true);
    setError(null);
    try {
      const result = await alertService.getAlertsByVmId(vmId, index);
      if (result.success) {
        setAlertsData(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getAlertSummary = async (vmId, startDate, endDate) => {
    setLoading(true);
    setError(null);
    try {
      const result = await alertService.getAlertSummary(vmId, startDate, endDate);
      if (result.success) {
        setSummaryData(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  const getAlertHeatmap = async (vmId) => {
    setLoading(true);
    setError(null);
    try {
      const result = await alertService.getAlertHeatmap(vmId);
      if (result.success) {
        setHeatmapData(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  };

  return {
    getAlertsByVmId,
    getAlertSummary,
    getAlertHeatmap,
    alertsData,
    summaryData,
    heatmapData,
    loading,
    error,
  };
};